<template>
    <!-- 学习基本信息 -->
    <div class="school_info_box">
        <div class="row school_info_row">
            <!-- 基本信息左边 -->
            <div class="col-sm-3 school_info_left">
                <div class="school_info_left_logo">
                    <img src="/img/logo.png" alt="">
                </div>
                <div class="school_name">
                    中心大学
                </div>

                <div class="use_number">
                    平台使用人数<span>|</span>19人
                </div>
                <div class="school_info_list">
                    <ul>
                        <li>
                            学校名称：中心大学
                        </li>
                        <li>
                            创办时间：2018-11-01
                        </li>
                        <li>
                            校长：刘备
                        </li>
                        <li>
                            副校长：诸葛亮
                        </li>
                        <li>
                            学校地址：河南省郑州市郑东新区
                        </li>
                        <li>
                            联系电话：40041142424
                        </li>
                        <li>
                           编辑信息
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 基本信息右边 -->
            <div class="col-sm-9 school_info_right">
                <div class="school_info_nav">
                    <ul>
                        <li v-for="(value,key) in navList" :key="key" @click="$Common.pageJump(value.page_path,2)">
                            <span>
                                <img :src="value.icon_path" alt="">
                                {{value.nav_name}}
                            </span>
                        </li>
                    </ul>
                </div>

                <div class="col-sm-7 school_info_data_content">
                    <div class="col-sm-6 nopadding">
                        <div class="school_info_data">
                            <div class="data_title">
                                <span>日常巡查数据</span>
                                <el-radio-group v-model="patrolStatistics" size="small" style="float:right">
                                    <el-radio-button label="whereDay">今天</el-radio-button>
                                    <el-radio-button label="whereWeek">本周</el-radio-button>
                                    <el-radio-button label="whereMonth">本月</el-radio-button>
                                </el-radio-group>
                            </div>
                            <div class="data_center">
                                <ul>
                                    <li>
                                        <span>471</span>
                                        巡查总数
                                    </li>
                                    <li>
                                        <span>143</span>
                                        已巡查数
                                    </li>
                                    <li>
                                        <span>328</span>
                                        未巡查数
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 nopadding">
                        <div class="school_info_data school_info_data_two">
                            <div class="data_title">
                                <span>安全隐患数据</span>
                            </div>
                            <div class="data_center">
                               <div class="data_center_left" ref="echarts_box" id="echarts_box">1212</div>
                               <div class="data_center_right">
                                   <span>隐患总数<b>16</b></span>
                                   <span>已处理数<b>16</b></span>
                               </div>
                            </div>
                        </div>
                    </div>
                    <!-- 代办事项 -->
                    <div class="col-sm-12 agency_matters_box">
                        <div class="agency_matters">
                            <div class="data_title">
                                <span>待办事项</span>
                                <span>查看更多</span>
                            </div>
                            <div class="todoBox">
                                <ul>
                                    <li v-for="(value, name) in todoData" :key="name">
                                        <span>{{value.name2}}</span>
                                        <span>{{value.name3}}</span>
                                        <span>点击查看</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-5 study_example_box">
                    <div class="study_example">
                        <div class="data_title">
                            <span>学校积分学习榜</span>
                        </div>
                        <el-table :data="rankingData"  height="628"  border  style="width: 100%">
                            <el-table-column  prop="ranking" label="排名"  >
                            </el-table-column>
                            <el-table-column  prop="name" label="用户名称"  >
                            </el-table-column>
                            <el-table-column  prop="integral" label="积分"  >
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import echarts from "echarts";
export default {
    name:'school_info',
    components: {},
    props: {},
    data() {
        return {
            // 巡查统计数据
            patrolStatistics:'whereDay',
            navList:[
                {
                    nav_name: '安全档案',
                    page_path: '/security_archives',
                    icon_path: '/img/icon_aqda.png',
                },
                {
                    nav_name: '专项检查',
                    page_path: '/',
                    icon_path: '/img/icon_zxjc.png',
                },
                {
                    nav_name: '安全会议',
                    page_path: '/',
                    icon_path: '/img/icon_aqhy.png',
                },
                {
                    nav_name: '通知公告',
                    page_path: '/',
                    icon_path: '/img/icon_tzgg.png',
                },
                {
                    nav_name: '任务下发',
                    page_path: '/',
                    icon_path: '/img/icon_rwxf.png',
                },
                {
                    nav_name: '日常检查',
                    page_path: '/',
                    icon_path: '/img/icon_rcjc.png',
                },
                {
                    nav_name: '隐患管理',
                    page_path: '/',
                    icon_path: '/img/icon_yhgl.png',
                },
                {
                    nav_name: '出入校管理',
                    page_path: '/',
                    icon_path: '/img/icon_crxgl.png',
                },
                {
                    nav_name: '应急演练中心',
                    page_path: '/',
                    icon_path: '/img/icon_yjylzx.png',
                },
                {
                    nav_name: '绩效评分',
                    page_path: '/',
                    icon_path: '/img/icon_jxpf.png',
                },
            ],
            labelPosition: 'whereDay',

            // 排名数据
            rankingData:[],

            // 待办事项数据
            todoData:[],
            todoDataPage:'',

            // 隐患数据
            hiddenDangerTotal :0,
            handleNumber: 0,

            // myChart:'',
        };

    },
    watch: {},
    computed: {},
    methods: {
        // 获取排名数据列表
        getrankingData(){
            for(var i=0;i <= 10;i++){
                this.rankingData[i] = {
                    // aid: 13+i,
                    ranking: i,
                    name: '夏侯惇',
                    integral: 200,
                }

            }
        },

        // 获取未办事件
        gettodoData(){
            for(var i=0;i <= 100;i++){
                this.todoData[i] = {
                    name1: i,
                    name2: '你有一份档案已过期，请处理',
                    name3: '2019-10-01',
                }



            }
        },
        echartsDanger() {
            this.$nextTick(()=>{
                var myChart =  echarts.init(this.$refs.echarts_box)
                var option = {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b}: {c} ({d}%)'
                    },
                        color: ['#1c71fb', '#ccc', ''],

                    series: [
                        {
                            name: '访问来源',
                            type: 'pie',
                            radius: ['50%', '70%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: '20',
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: [
                                {value: 335, name: '安全隐患总数'},
                                {value: 310, name: '未完成安全隐患数'},
                            ]
                        }
                    ]
                };

                myChart.setOption(option);
                
            })



            

            
        },
    },
    created() {
        this.getrankingData()
        this.gettodoData()
        this.echartsDanger()
    },
    mounted() {}
};
</script>
<style scoped>
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
background-color: #d3dce6;
}
@import '/css/base.css';
@import '/css/SchoolInfo.css';
</style>